import axios from "axios";
import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { baseUrl, baseimgUrl, userLocation, ipAddress, userName } from '../Univ.js';
import { Autocomplete, TextField } from '@mui/material';

function AddDrugGeneric() {
    const [cat, setCat] = useState([]);
    const [cats, setCats] = useState([]);
    const [manus,setManus] = useState([]);
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [catData, setCatData] = useState({
        "generic": '',
        "schedule": '',
        "manu": '',
        "status": '',
        "addedby": '',
        "ip_add": ''
    });

    const handleChange = (event) => {
        setCatData({
            ...catData,
            [event.target.name]: event.target.value
        });
    }
    useEffect(() => {
        const fetchManufacturers = async () => {
            try {
                const response = await axios.get(`${baseUrl}add-manufacturer/`);
                setManus(response.data);
            } catch (error) {
                console.log(error);
            }
        };

        fetchManufacturers();
    }, []);
    useEffect(() => {
        fetchPharmData();
    }, []);

    function fetchPharmData(page = 1, pageSize = 5000) {
        const totqtyParam = 'gt0';  // Adjust filter parameter as needed
        const queryParams = `totqty=${totqtyParam}&page=${page}&page_size=${pageSize}`;

        axios.get(`${baseUrl}pharm-search/?${queryParams}`)
            .then((pharmResponse) => {
                setCats(pharmResponse.data);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('product', catData.product);
        _formData.append('generic', catData.generic);
        _formData.append('schedule', catData.schedule);
        _formData.append('manu', catData.manu);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);

        try {
            axios.post(baseUrl + 'add-generic/', _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200 || response.status == 201) {
                        console.log(response.data);
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 3000,
                            showConfirmButton: false
                        });

                    }
                });
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
    if (cats.length > 0) {
        const filteredRows = cats.filter(row => row.schedule !== null);
        // Only update rows if there is a change
        if (filteredRows.length > 0 && JSON.stringify(filteredRows) !== JSON.stringify(rows)) {
            setRows(filteredRows);
        }
    }
    }, [cats]);
    const columns = [
        { field: 'id', headerName: 'Id', width: 60 },
                {
          field: 'manu',
          headerName: 'Manu',
          width: 150,
          renderCell: (params) => {
            return params.row.manu ? params.row.manu.name : 'Unknown';
          },
        },
        { field: 'product', headerName: 'Product', width: 500 },
        { field: 'schedule', headerName: 'Schedule', width: 150 },
        { field: 'generic', headerName: 'Generic', width: 450 },
        { field: 'addedby', headerName: 'Added By', width: 120 },
        { field: 'action', headerName: 'Action',
          renderCell: (params) => (
              <Link target="_blank" to={`/edit-generic/${params.row.id}/`} className="btn btn-warning">
                Edit
              </Link>
          ),
        width: 80,
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        },
    ];

    const uniqueProducts = [...new Set(cats.map(category => category.product.trim()))].map(product => ({ label: product }));

    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Add Generic Details</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="product" className="form-label">Category</label>
                                    <Autocomplete
                                        id="combo-box-product"
                                        options={uniqueProducts}
                                        getOptionLabel={(option) => option.label}
                                        onChange={(event, value) => setCatData(prevState => ({ ...prevState, product: value ? value.label : '' }))}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Choose Product" name="product" variant="outlined" />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.label === value.label}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="schedule" className="form-label">Schedule</label>
                                    <select name="schedule" value={catData.schedule} onChange={handleChange} className="form-control">
                                        <option>Choose Schedule Type</option>
                                        <option value="H-Scheduled">H Schedule</option>
                                        <option value="H1-Scheduled">H1 Schedule</option>
                                        <option value="A-Scheduled">A Schedule</option>
                                        <option value="G-Scheduled">G Schedule</option>
                                        <option value="Schedule">Schedule</option>
                                        <option value="Non-Scheduled">Non Schedule</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="generic" className="form-label">Generic</label>
                                    <textarea className="form-control" tabIndex="0" name="generic" id="generic"
                                        value={catData.generic} onChange={handleChange} required>
                                    </textarea>
                                </div>
                                <div className="col-md-3 mb-3">
                                <label htmlFor="manu" className="form-label">Manufacturer</label>
                                <select name="manu" id="manu"  value={catData.manu} onChange={handleChange} className="form-control">
                                <option>Choose Manufacturer</option>
                                        {manus.map((manuf,index) => {return <option key={index} value={manuf?.id}>{manuf.name}
                                        </option>})}
                                    </select>
                                </div>
                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ height: "100%", width: "100%" }}>
                <DataGrid className="mt-4"
                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}
                    pageSize={28}
                    rows={rows}
                    columns={columns}
                    components={{
                        Toolbar: GridToolbar,
                    }}
                    autoHeight
                />
            </div>
        </section>
    )
}

export default AddDrugGeneric;
